var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height"
  }, [_c('texting-form', _vm._g(_vm._b({}, 'texting-form', _vm.props__texting, false), {
    posted: _vm.posted
  }))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }